import requests from "../agent";

const Perfil = {
  getAll: () => requests.get("/Perfil/GetPerfiles"),
  /*getAllByFilter: (data) => requests.post("Proveedores/GetProveedoresFiltro", data),
  activeOrInactive: (data) => requests.put("Proveedores/ActivarDesactivarProveedor", data),*/
  //create: (data) => requests.post("Usuario/CreateProveedor", data),
  //update: (data) => requests.put("Usuario/UpdateProveedor", data),
  /*delete: (id) => requests.delete(`Proveedores/DeleteProveedor/${id}`),*/
};

export default Perfil;
